import React from "react"
import { HeadProps, graphql } from "gatsby"

import {
  Layout,
  Cover,
  Hero,
  HorizontalSlider,
  Seo
} from "components/case-study"

import cover from "images/case-studies/seaspan/cover.jpg"
import logo from "images/case-studies/seaspan/logo.png"
import sparkline from "images/case-studies/seaspan/sparkline.jpg"
import screenshot1 from "images/case-studies/seaspan/screenshot-1.jpg"
import screenshot2 from "images/case-studies/seaspan/screenshot-2.jpg"
import iPhones from "images/case-studies/seaspan/iphones.png"
import iPad from "images/case-studies/seaspan/ipad.png"
import board from "images/case-studies/seaspan/board.jpg"

export default function SeaspanCaseStudy() {
  return (
    <Layout>
      <Cover image={cover}>
        <div className="mx-auto lg:w-2/3">
          <h1>Stage 3 Systems: SVRS Web Design &&nbsp;Development</h1>

          <div className="space-y-4 text-sm sm:text-base">
            <p>
              Seaspan Vessel Reporting System - tracking the efficiency.
              Sometimes dashboard means something more than a bunch of numbers
              and pie charts. Sometimes, especially when you are running vessels
              carrying 300,000 metric tonnes of cargo, you really need to see
              what&apos;s happening right now. All that cargo amounts to a large
              investment and when Seaspan needed a way to protect investment
              they came to us to come up with something efficient and elegant to
              help them.
            </p>

            <p>
              Our solution is essentially an implementation of the
              &ldquo;sparkline&rdquo; concept introduced by Edward Tufte in his
              masterpiece Beautiful Evidence. For Seaspan we implemented it in
              such a way that a vessel manager easily grasps everything that
              brakes pre-calculated limits.
            </p>
          </div>
        </div>
      </Cover>

      <div className="container pb-24 text-center">
        <div className="mx-auto space-y-24 lg:w-2/3">
          <Hero className="mt-24 sm:-mt-24">
            <div className="mb-4 flex flex-wrap items-center justify-center gap-6">
              <img className="hero__logo" src={logo} alt="Seaspan logo" />
              <img alt="Seaspan Sparkline" src={sparkline} />
            </div>

            <p>
              Thanks to coloured zones it&apos;s easy to see any suboptimal
              performance and take needed actions before things get out of
              control.
            </p>
          </Hero>

          <section>
            <HorizontalSlider>
              <img alt="Seaspan Interface screenshot 1" src={screenshot1} />
              <img alt="Seaspan Interface screenshot 2" src={screenshot2} />
            </HorizontalSlider>
          </section>

          <section>
            <p className="mb-4">
              Mobile access on iPhone, iPad and other devices becomes essential
              when you need to make on-the-spot decisions and require critical
              information and the ability to sign your real signature to make it
              official.
            </p>
            <img className="inline-block" src={iPhones} alt="iPhone" />
            <img className="inline-block" src={iPad} alt="iPad" />
          </section>

          <section>
            <p className="mb-4">
              And if you are in the office, it’s great to see what’s going on
              real-time on a huge screen on the wall.
            </p>

            <img className="w-full shadow-xl" alt="Seaspan Board" src={board} />
          </section>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query SeaspanPage {
    metaImage: file(name: { eq: "seaspan" }) {
      publicURL
    }
  }
`

export const Head = (headProps: HeadProps<Queries.SeaspanPageQuery>) => {
  if (
    headProps.data.metaImage === null ||
    headProps.data.metaImage.publicURL === null
  )
    throw new Error("Meta image for Seaspan case study is missing")

  return (
    <Seo
      title="Stage 3 Systems: SVRS Web Design & Development"
      description="Web design and Rails Development for Transportation Business in North Vancouver, BC."
      metaImageUrl={headProps.data.metaImage.publicURL}
      {...headProps.location}
    />
  )
}
